import React from 'react';
import Modal from './Modal';
import './Modal.css';

const ALL_AMOUNTS_DISPLAY = [
  { value: 0.1, display: '1 ban' },
  { value: 1, display: '1 leu' },
  { value: 5, display: '5 lei' },
  { value: 10, display: '10 lei' },
  { value: 20, display: '20 lei' },
  { value: 50, display: '50 lei' },
  { value: 75, display: '75 lei' },
  { value: 100, display: '100 lei' },
  { value: 250, display: '250 lei' },
  { value: 500, display: '500 lei' },
  { value: 700, display: '700 lei' },
  { value: 900, display: '900 lei' },
  { value: 1000, display: '1.000 lei' },
  { value: 2500, display: '2.500 lei' },
  { value: 5000, display: '5.000 lei' },
  { value: 7500, display: '7.500 lei' },
  { value: 10000, display: '10.000 lei' },
  { value: 12500, display: '12.500 lei' },
  { value: 15000, display: '15.000 lei' },
  { value: 20000, display: '20.000 lei' },
  { value: 25000, display: '25.000 lei' },
  { value: 50000, display: '50.000 lei' },
  { value: 75000, display: '75.000 lei' },
  { value: 100000, display: '100.000 lei' },
];
const valueToDisplay = Object.fromEntries(ALL_AMOUNTS_DISPLAY.map(a => [a.value, a.display]));

export default function RemovedAmountsModal({ open, onClose, roundAmountsOrder = {} }) {
  const rounds = Object.keys(roundAmountsOrder)
    .map(Number)
    .sort((a, b) => a - b);

  const hasAny = rounds.some(r => roundAmountsOrder[r]?.length > 0);

  return (
    <Modal open={open} onClose={onClose}>
      <h2 style={{ color: '#ffd700', textAlign: 'center', marginTop: 0, marginBottom: 16 }}>
        Cutii eliminate
      </h2>
      {!hasAny ? (
        <p style={{ color: '#fff', textAlign: 'center' }}>Nicio cutie eliminată.</p>
      ) : (
        <div style={{ color: '#fff' }}>
          {rounds.map(r => {
            const amounts = roundAmountsOrder[r] || [];
            if (amounts.length === 0) return null;
            return (
              <div key={r} style={{ margin: '12px 0' }}>
                <div style={{ color: '#ffd700', fontWeight: 700, marginBottom: 4 }}>Runda {r}</div>
                <div>
                  {amounts.map((v, i) => (
                    <span key={i} style={{ display: 'inline-block', marginRight: 8, color: '#fff', background: '#222', borderRadius: 6, padding: '2px 10px', fontWeight: 500 }}>
                      {valueToDisplay[v] ?? v}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
}
